export const async_ebay_product = {
  asyncType: 'ebay-product',
  hostedScraperType:  'async_ebay_product',
  publicHostedScraperAPIType:  'ebay_product',
  inputKey: 'productId',
  inputsKey: 'productIds',
  inputJsonSchema: { type: 'string' },
  asyncEndpoint: '/structured/ebay/product',
  apiEndpoint: '/structured/ebay/product',
  apiCostEndpoint: '/account/ebayproductcost',
  propertiesJsonSchemaPart: {
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' }
  }
};
